<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="deleteProyecto"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionMapEnrollmentsFamilyMembersModalDelete.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section
        v-if="showLoadingState"
        key="loadingState"
        class="m-the-modal-section"
      >
        <AtomLoadingSecondary/>
      </section>
      <section
        v-else
        key="modalSection"
        class="m-the-modal-section"
      >
        <p>
          {{ $t('mEditionMapEnrollmentsFamilyMembersModalDelete.messageDelete.element') }}
          <b>{{ element.miembro.razon_social }}</b>
          {{ $t('mEditionMapEnrollmentsFamilyMembersModalDelete.messageDelete.options') }}
          <b>{{ familia.nombre }}</b>
        </p>
        <small class="font-weight-bold text-color-danger">
            {{ $t('mEditionMapEnrollmentsFamilyMembersModalDelete.messageDelete.notReversed') }}
        </small>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionMapEnrollmentsFamilyMembersModalDelete.buttonCancel')"/>
        <AtomButtonPrimary
          v-if="Object.values(element).length"
          :button-primary="buttonPrimary"
        />
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapsEnrollmentsFamilyMembersModalDelete',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionMapEnrollmentsFamilyMembersModalDelete.buttonPrimary'),
        behavior: 'delete',
        class: 'a-button-danger-primary',
        sending: false,
        type: 'submit'
      },

      element: {},
      eliminados: [],
      familia: {},
      showLoadingState: true
    }
  },

  created () {
    this.element = Object.assign({}, this.$modal.element)
    this.familia = Object.assign({}, this.$store.getters.getAssetSelectedFamily)
    this.showLoadingState = false
  },

  methods: {
    deleteProyecto () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.eliminados.push(this.element.miembro.inscripcion)
        this.$services.update('familia', 'deleteFamiliaMiembro', { 'alumnos': this.eliminados }, [this.element.miembro.familia])
          .then(response => {
            this.$modal.updateData('deleteElement')
            this.$modal.closeModal()
            this.$license.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mEditionMapEnrollmentsFamilyMembersModalDelete', 'deleteIntegrante', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$modal.closeModal()
            this.$modal.showModal('MoleculeFeedAssetsContentModalProductoActivo')
            this.$license.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mEditionMapEnrollmentsFamilyMembersModalDelete', 'deleteIntegrante', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
